/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import { JOBS_GET_ALL } from './actions.type';
import { JOBS_SET_STORE, JOBS_SET_SELECTFIELDOPTIONS } from './mutations.type';
import { JOBS_GET_JOB_BY_ID } from './getters.type';
import { APIGET } from '../utils/apiHelper';

// initial state
const state = {
  jobs: [
    {
      jobId: 7,
      title: 'Adminisztrátor',
      desc: 'Szívesen dolgoznál modern, fiatalos környezetben, egy dinamikusan fejlődő csapatban? Érdekelnek a mobilkommunikációs eszközök? Akkor várjuk jelentkezésed!',
      imgPath: 'placeholder_6.jpg',
      language: 'hu',
      divisionId: 1,
      divisionName: 'Logisztika',
      jobDetails: [
        {
          title: 'Főbb feladataid közé tartoznának:',
          list: [
            'Munkalapok rögzítése, szervizadminisztráció',
            'Beérkező készülékek, tartozékok és garancia ellenőrzése',
            'A készülékek nyomon követése',
            'Partnerekkel való kapcsolattartás német nyelven',
            'E-mailben érkező megkeresések megválaszolása akár német nyelven',
            'Jelentések, riportok, beszámolók készítése a vezetőség felé',
          ],
        },
        {
          title: 'Várjuk jelentkezésed, ha:',
          list: [
            'középfokú végzettséggel rendelkezel',
            'német nyelven, középfokon kommunikálsz szóban és írásban',
            'munkádat precízen és pontosan végzed',
            'felhasználói szinten kezeled az irodagépeket és számítógépes alkalmazásokat',
            'önállóan és csapatban is tudsz dolgozni',
            'megbízható és felelősségteljes hozzáállás jellemez',
          ],
        },
        {
          title: 'Elvárásaink:',
          list: [
            'Minimum középfokú végzettség',
            'Magas szintű MS Office (legfőképp Excel) ismeretek',
            'AKTÍV középszintű angol nyelvtudás szóban és írásban (a mindennapi munkához elengedhetetlen)',
            'Önállóan és csapatban történő munkavégzés képessége',
            'Precizitás',
            'Rugalmasság',
            'Analitikus gondolkodásmód',
          ],
        },
        {
          title: 'Amit kínálunk:',
          list: [
            'Stabil hosszú távú munkalehetőséget biztosítunk számodra',
            'Bejárásod támogatjuk (tömegközlekedés esetén 100%, személygépkocsi esetén 15 Ft/km)',
            'A próbaidő elteltével Cafeteriára is jogosult leszel, melyet készpénzre és/vagy SZÉP kártyára is igényelhetsz',
            'Folyamatos fejlődési lehetőséget kínálunk, képzésekkel, karrier utakkal',
            'A lojális munkatársainkat megbecsüljük, elismerjük (törzsgárda jutalom)',
            'A családias és jó hangulat érdekében számos céges programon és rendezvényen vehetsz részt (Évindító rendezvény, Családi nap)',
            'Fontos számunkra az egészséges életmód, így ehhez hozzájárulva szervezünk gyümölcsnapokat és kedvezményes sportolási lehetőségeket',
            'Munka-magánélet egyensúlyát támogatva széleskörű szociális juttatásokat biztosítunk',
          ],
        },
        {
          title: 'Előnyt jelent:',
          list: [
            'középfokú angol nyelvtudás szóban és írásban egyaránt',
          ],
        },
        {
          title: 'Szükséges nyelvtudás:',
          list: [
            'Német társalgási szint',
          ],
        },
        {
          title: 'Szükséges tapasztalat:',
          list: [
            'Mindegy, vagy nem igényel tapasztalatot',
          ],
        },
        {
          title: 'Szükséges végzettség:',
          list: [
            'Középiskola',
          ],
        },
        {
          title: 'Foglalkoztatás jellege:',
          list: [
            'Teljes munkaidő, két műszak',
          ],
        },
      ],
    },
    {
      jobId: 1,
      title: 'Anyagmozgató',
      desc: 'Ha szívesen dolgoznál modern, fiatalos környezetben, dinamikusan fejlődő csapatban és érdekelnek a mobilkommunikációs eszközök, akkor várjuk jelentkezésed anyagmozgató csapatunkba!',
      imgPath: 'placeholder_6.jpg',
      language: 'hu',
      divisionId: 4,
      divisionName: 'Logisztika',
      jobDetails: [
        {
          title: 'Főbb feladatok, munkák:',
          list: [
            'Csomagok átadása- átvétele', 'Csomagok összekészítése', 'Készülékek kamerázása', 'Készülékek mozgatása az épületen belül',
          ],
        },
        {
          title: 'Az álláshoz tartozó elvárások',
          list: [
            'Nyitottság az önálló és csapatban történő munkavégzésre', 'Precizitás', 'Két műszakban (06:00-14:30 és 11:30-20:00) történő munkavégzés vállalása',
          ],
        },
        {
          title: 'Amit kínálunk',
          list: [
            'Hétfőtől péntekig tartó munkavégzés', 'Jó munkakörülmények', 'Határozatlan idejű szerződés, akár azonnali kezdéssel', 'Fix bér, cafeteria, bejárás támogatás',
          ],
        },
      ],
    },
    {
      jobId: 2,
      title: 'Mobiltelefon tesztelő',
      desc: 'Szívesen dolgoznál modern, fiatalos környezetben, egy dinamikusan fejlődő csapatban? Érdekelnek a mobilkommunikációs eszközök? Akkor várjuk jelentkezésed!',
      imgPath: 'placeholder_6.jpg',
      language: 'hu',
      divisionId: 10,
      divisionName: 'Teszt',
      jobDetails: [
        {
          title: 'Feladat',
          list: [
            'A megjavított készülékek ellenőrzése, tesztelése',
            'Az elektronikai termékek minőségének ellenőrzése, dokumentálása',
            'A tesztelési folyamatokhoz szükséges adminisztráció elvégzése',
          ],
        },
        {
          title: 'Elvárásaink',
          list: [
            'Hasonló munkakörben szerzett tapasztalat előnyt jelent',
            'Megbízható számítástechnikai ismeretek (gyakorlott Windows felhasználó)',
            'Két műszakban történő munkavégzés vállalása',
          ],
        },
        {
          title: 'Amire számíthatsz',
          list: [
            'Hétfőtől péntekig tartó munkavégzés',
            'Jó munkakörülmények és még jobb csapat vár rád',
            'Akár azonnali munkakezdés',
            'Céges rendezvények',
            'Belépéskor szakmai képzés és pártfogó melletti betanulás',
            'Versenyképes alapbér',
            'Cafeteria: SZÉP kártya',
          ],
        },
        {
          title: 'Állás, munka területe(i)',
          list: [
            'Szakmunka', 'Műszerész', 'Gyártás, termelés', 'Minőségellenőrzés',
          ],
        },
        {
          title: 'Szükséges tapasztalat',
          list: [
            'Nem igényel tapasztalatot',
          ],
        },
        {
          title: 'Szükséges végzettség',
          list: [
            'Szakiskola/szakmunkás képző',
          ],
        },
      ],
    },
    /* {
      jobId: 3,
      title: 'Készletező logisztikus',
      desc: 'Szívesen dolgoznál modern, fiatalos környezetben, egy dinamikusan fejlődő csapatban? Érdekelnek a mobilkommunikációs eszközök? Akkor várjuk jelentkezésed!',
      imgPath: 'placeholder_6.jpg',
      language: 'hu',
      divisionId: 4,
      divisionName: 'Logisztika',
      jobDetails: [
        {
          title: 'Főbb feladataid közé tartoznának:',
          list: [
            'Alkatrészek és készülékek kezelése, pontos adminisztráció a számítógépes rendszerekben',
            'Készlettervek készítése, nyilvántartása',
            'A szerviztevékenység munkálataihoz szükséges alkatrészek megrendelése, rendszerezése, kiadása',
            'Hibás beérkezések kapcsolatos reklamációk, kezelésük',
            'Visszaküldések kivitelezése',
            'Alkatrészre váró készülékek teljes körű kezelése, nyomon követése',
            'Szerviztechnikusokkal történő napi kapcsolattartás',
            'Beszállítói kapcsolattartás (e-mailben, angol nyelven is)',
            'Folyamatok optimalizálása, raktári rend fenntartása ',
            'Szoros együttműködés a szervizzel, a raktárral és a társterületekkel, valamint a budaörsi központtal',
          ],
        },
        {
          title: 'Elvárásaink:',
          list: [
            'Minimum középfokú végzettség',
            'Magas szintű MS Office (legfőképp Excel) ismeretek',
            'AKTÍV középszintű angol nyelvtudás szóban és írásban (a mindennapi munkához elengedhetetlen)',
            'Önállóan és csapatban történő munkavégzés képessége',
            'Precizitás',
            'Rugalmasság',
            'Analitikus gondolkodásmód',
          ],
        },
        {
          title: 'Előnyt jelent:',
          list: [
            'Logisztikai, készletezési tapasztalat',
            'Műszaki szemlélet',
          ],
        },
      ],
    }, */
    /* {
      jobId: 4,
      title: 'Főkönyvelő',
      desc: 'Központi irodánk pénzügyi csapatába keresünk főkönyvelő munkatársat.',
      imgPath: 'placeholder_6.jpg',
      language: 'hu',
      divisionId: 6,
      divisionName: 'Pénzügy',
      jobDetails: [
        {
          title: 'Feladatok:',
          list: [
            'A számviteli és adózási terület irányítása, egységes szakmai elvek meghatározása és a zavartalan működés feltételeinek biztosítása',
            'Számviteli politika és belső szabályzatok naprakészen tartása, működtetése',
            'Éves beszámolók készítése, közzététele',
            'Konszolidált beszámolók összeállítása és közzététele',
            'Az adójogszabályokkal kapcsolatos ismeretek folyamatos fejlesztése és naprakészen tartása',
            'Adók és egyéb költségvetési források pontos számítása és bevallása',
            'Pénzügyi és gazdasági ügyekben történő döntések előkészítését és támogatását szolgáló feladatok ellátása',
            'Könyvvizsgálat és adóvizsgálat lebonyolítása',
          ],
        },
        {
          title: 'Várjuk jelentkezésed, ha:',
          list: [
            'Szakirányú felsőfokú végzettséggel rendelkezel',
            'Hasonló területen szerzett – legalább 3 éves – szakmai tapasztalatod van',
            'Naprakész adózási és számviteli ismeretekkel rendelkezel',
            'Magabiztosan kezeled az MS Office programjait',
            'Proaktív és együttműködő személyiség vagy',
            'Munkádat felelősségteljesen és precízen végzed',
            'Legalább kommunikációs szintű az angol nyelvtudásod',
          ],
        },
        {
          title: 'Előnyt jelent:',
          list: [
            'IFRS könyvelési tapasztalat',
          ],
        },
        {
          title: 'Amit kínálunk:',
          list: [
            'Stabil háttér, hosszú távú együttműködés',
            'Béren kívüli juttatások',
            'Folyamatos szakmai fejlődés',
            'Kiváló munkakörülmények',
            'Fiatal, dinamikus csapat, jó hangulat',
          ],
        },
      ],
    }, */
    {
      jobId: 5,
      title: 'Mobiltelefon szerelő',
      desc: 'Ha szívesen dolgoznál modern, fiatalos környezetben, dinamikusan fejlődő csapatban és érdekelnek, a mobilkommunikációs eszközök, várjuk jelentkezésed!',
      imgPath: 'placeholder_6.jpg',
      language: 'hu',
      divisionId: 9,
      divisionName: 'Szerviz',
      jobDetails: [
        {
          title: 'Feladat',
          list: [
            'A beérkezett készülékek diagnosztizálása, hibakeresés',
            'Mobiltelefonok modul szintű javítása, alkatrészek cseréje',
            'A javítási munkálatok adminisztrációja',
            'Gyártói szoftverek kezelése',
          ],
        },
        {
          title: 'A pozíció betöltéséhez szükséges',
          list: [
            'Pontos, precíz munkavégzés',
            'Jó problémamegoldó képesség',
            'Megbízhatóság',
          ],
        },
        {
          title: 'Amit kínálunk',
          list: [
            '1 műszakban, hétfőtől - péntekig tartó munkavégzés (08:00-16:30)',
            'Belépéskor átfogó szakmai képzés',
            'Karrierszintek',
            'Szakmai/megszerzett tapasztalat alapján differenciált, versenyképes alapbér + prémium rendszer',
            'Modern munkakörülmények és kiváló csapat vár rád',
            'Azonnali munkakezdés',
            'Cafeteria: SZÉP kártya vagy készpénz',
            'Dolgozói kedvezmény mobiletelefonok javítására',
            'Céges rendezvények',
            'Szociális támogatások lehetősége',
            'Cégen belül elérhető büfé, étkező',
            'Munkába járási támogatás',
          ],
        },
        {
          title: 'Nálunk a helyed, ha',
          list: [
            'Érdeklődsz műszaki dolgok iránt',
            'Hasonló munkakörben szerzett tapasztalatod van',
            'Összeszerelésben, egyedi gyártásban szerzett tapasztalatod van',
            'Megbízható számítástechnikai ismeretekkel rendelkezel (gyakorlott Windows felhasználó vagy)',
            'Érdekel a mobiltelefonok világa',
            'Zsigereidben van a bütykölés',
            'Szeretnél egy folyamatosan fejlődő iparágban dolgozni',
            'Jó problémamegoldó készséged van',
          ],
        },
        {
          title: 'Előnyt jelent',
          list: [
            'Elektronikai vagy mechanikai műszerész esetleg mechatrotechnikusi végzettség',
          ],
        },
      ],
    },
    /* {
      jobId: 6,
      title: 'Ügyfélkapcsolati adminisztrátor',
      desc: 'Központi irodánkba keresünk ügyfélkapcsolati adminisztrátor munkatársat.',
      imgPath: 'placeholder_6.jpg',
      language: 'hu',
      divisionId: 2,
      divisionName: 'Call center ügyintézés',
      jobDetails: [
        {
          title: 'Feladatok:',
          list: [
            'E-mailben érkező megkeresések megválaszolása',
            'Telefonon beérkező hívások udvarias, gyors és pontos fogadása, a felmerülő kérdések megválaszolása, akár angol nyelven is',
            'E-mail-en és telefonon beérkező panaszok magas szintű kezelése az elégedettség fenntartása érdekében, akár angol nyelven is',
            'Munkalapok rögzítése, szervizadminisztráció',
            'Jelentések, riportok, beszámolók készítése a vezetőség felé.',
          ],
        },
        {
          title: 'Várjuk jelentkezésed, ha:',
          list: [
            'Minimum középfokú végzettséggel rendelkezel',
            'Társalgási szintű angol nyelvtudásod van (szóban és írásban egyaránt)',
            'Ügyfélcentrikus szemléletmód jellemez',
            'Magas szintű problémamegoldó képességgel rendelkezel',
            'Munkádat precízen, pontosan végzed',
            'Felhasználói szinten kezeled az irodagépeket és számítógépes alkalmazásokat',
            'Kiváló szóbeli és írásbeli kommunikációs készséggel rendelkezel',
          ],
        },
        {
          title: 'Előnyt jelent:',
          list: [
            'Ügyfélszolgálati/call centeri tapasztalat',
            'Fogyasztóvédelmi referens végzettség',
          ],
        },
        {
          title: 'Amit kínálunk:',
          list: [
            'Stabil háttér, hosszú távú együttműködés',
            'Béren kívüli juttatások',
            'Folyamatos szakmai fejlődés',
            'Kiváló munkakörülmények',
            'Fiatal, dinamikus csapat, jó hangulat',
          ],
        },
      ],
    }, */
  ],
  jobsForSelectFieldOptions: [
    {
      text: 'Válasszon', value: 999,
    },
  ],
};

// getters
const getters = {
  // getJobById: state => jobId => state.jobs.find(job => job.jobId == jobId),
};

// actions
const actions = {
  async [JOBS_GET_ALL](context, payload) {
    context.commit(JOBS_SET_STORE, payload);
  },
  async [JOBS_GET_JOB_BY_ID](context, jobId) {
    const job = await context.state.jobs.find(job => job.jobId == jobId);
    return job;
  },
};

// mutations
const mutations = {
  [JOBS_SET_STORE](state, payload) {
    state.jobs = payload;
    state.jobs.forEach(job => {
      job.path = job.title.replace(/ /g, '-').toLowerCase();
    });
  },
  [JOBS_SET_SELECTFIELDOPTIONS](state) {
    state.jobsForSelectFieldOptions = [];
    state.jobs.forEach(job => {
      state.jobsForSelectFieldOptions.push({
        text: job.title, value: job.jobId,
      });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
